import { createSelector } from 'reselect';
import { reduxKey } from './constants';
import { ConfigState } from './types';

export const getConfig = state => state[reduxKey] || {};

export const getConfigKey = createSelector(
  getConfig,
  (_, name: keyof ConfigState) => name,
  (configState, name) => {
    return configState[name];
  }
);
